'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbMinDateValidator = fbMinDateValidator;

var _dateTimeHelper = require('./dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fbMinDateValidator() {
    'ngInject';

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {

            var dateTimeHelper = new _dateTimeHelper2.default(attrs.format || _dateTimeHelper2.default.defaultDateFormat);

            attrs.$observe('fbMinDate', function () {
                ngModel.$validate();
            });

            var compareLevel = 'day';

            if (dateTimeHelper.formatHasSeconds) {
                compareLevel = 'second';
            } else if (dateTimeHelper.formatHasMinutes) {
                compareLevel = 'minute';
            } else if (dateTimeHelper.formatHasHours) {
                compareLevel = 'hour';
            }

            ngModel.$validators.minDate = function (modelValue /*, viewValue*/) {
                if (!attrs.fbMinDate) {
                    // consider valid when no value provided
                    return true;
                }
                if (ngModel.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }

                var minDate = (0, _moment2.default)(attrs.fbMinDate);

                // if (!minDate.isValid()) {
                //     // consider true when no valid min date provided
                //     return true;
                // }

                var val = modelValue;
                if (typeof val === 'string' && val.indexOf('+') !== -1) {
                    val = val.substr(0, val.indexOf('+'));
                }
                var dateValue = (0, _moment2.default)(val);

                // if (!dateValue.isValid()) {
                //     // consider true when no valid date provided
                //     return true;
                // }

                if (dateValue.isSameOrAfter(minDate, compareLevel)) {
                    return true;
                }

                // its invalid
                return false;
            };
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/datepicker/minDateValidator.directive.js
// module id = 711
// module chunks = 0